'use client';

import { useEffect } from 'react';
import { WindowWithWebengage } from '@/features/webengage/types';
declare const window: WindowWithWebengage;
export default function Pwa() {
  let sw: ServiceWorkerContainer | undefined;
  if (typeof window !== 'undefined') {
    sw = window?.navigator?.serviceWorker;
  }
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        if (registration.active && registration.active.scriptURL.includes('najva')) {
          registration.unregister();
        }
      });
    });
  }, []);
  useEffect(() => {
    if (sw) {
      sw.register('/sw.js', {
        scope: '/'
      }).then(registration => {
        // eslint-disable-next-line no-console
        console.log('Service Worker registration successful with scope: ', registration.scope);
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log('Service Worker registration failed: ', err);
      });
    }
  }, [sw]);
  return null;
}